import * as React from 'react';
import { Icon } from 'semantic-ui-react';

interface Props {
  className?: string;
}

export class OfflineIcon extends React.Component<Props> {
  public render() {
    const className = this.props.className ? this.props.className : '';
    return <Icon name="dot circle outline" color="red" className={className}/>;
  }
}


// WEBPACK FOOTER //
// ./src/components/connection-status/offline-icon.tsx